import { render, staticRenderFns } from "./ServicesRegistryList.vue?vue&type=template&id=00ecc9c8"
import script from "./ServicesRegistryList.vue?vue&type=script&lang=js"
export * from "./ServicesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports